import React from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import request from 'common/request';

class ReportIssuePopup extends React.Component {
  constructor(props) {
    super(props);

    this.onClickReport = this.onClickReport.bind(this);
  }

  onClickReport(e) {
    e.preventDefault();
    const { content } = this.props;

    swal({
      title: 'Report an issue',
      input: 'textarea',
      inputPlaceholder: 'Type your message here...',
      showCloseButton: true,
      showCancelButton: true
    }).then(function (result) {
      if (result.dismiss) return;

      swal.showLoading();
      request.post('/report-issue', {
        report: result.value,
        content
      }).then(function () {
        swal.hideLoading();
      }).catch(function ({ response }) {
        swal.hideLoading();
        swal({
          type: 'error',
          title: 'Error',
          text: response.data
        });
      });
    });
  }

  render() {
    return (
      <a
        className='nav-item is-tab'
        onClick={this.onClickReport}
      >
        Report an issue
      </a>
    );
  }
}

const mapStateToProps = (state) => {
  const { reportIssue } = state;
  return {
    content: (reportIssue) ? reportIssue.content : 'n/a'
  };
};

export default connect(mapStateToProps)(ReportIssuePopup);



// WEBPACK FOOTER //
// ./src/common/ReportIssuePopup.jsx